import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, tap } from 'rxjs';
import { BankService } from 'src/app/shared/services/bank.service';
import { deleteBank, editBank, loadBank, loadBankSuccess, saveBank } from './bank.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';



@Injectable()
export class BankEffects {
  constructor(private service: BankService, private action$: Actions, private notify: NotifyService) {}

  loadBank$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadBank),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadBankSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );
}
